import { GET, POST, PUT } from "./common/http";
import { BASE_URL } from "./common/const";
import axios from "axios";

export const GetStakeRelationList = (params: any) =>
  GET(`${BASE_URL}/stakeRelation/list?` + params, null);

export async function handleUpdateStakeRelation(
  STAKEUID: number,
  PARENT_STAKE_ID: number | null,
  STAKEMAPUID: number
) {
  return axios.put(`${BASE_URL}/stakeRelation/update-relation`, {
    STAKEUID,
    PARENT_STAKE_ID,
    STAKEMAPUID,
  });
}

export async function UpdateParentStackDelete(
  UID: number,
  PARENT_STAKE_ID: number | null,
  STAKEMAPUID: number
) {
  return axios.put(`${BASE_URL}/stakeRelation/delete-parent`, {
    UID,
    PARENT_STAKE_ID,
    STAKEMAPUID,
  });
}

export async function handleUpdateEdge(
  UID: number,
) {
  return axios.put(`${BASE_URL}/stakeRelation/delete-edge`, {
    UID,
  });
}
